
export default function ContactSection() {
  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-blue-900 to-blue-800">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Visit Our <span className="text-yellow-400">Sarasota</span> Location
          </h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            Conveniently located in Sarasota, Florida. Our knowledgeable staff is ready to help 
            you with all your CPAP and BiPAP equipment needs.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Contact Information */}
          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <div className="flex items-center space-x-4 mb-8">
              <img 
                src="https://static.readdy.ai/image/6214d334b00eb7faf97c61a8b8784857/89e3759e831ea9226f20f25512a960ed.png" 
                alt="MediMar Medical Market Logo" 
                className="h-16 w-auto"
              />
            </div>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-fill text-blue-900 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-blue-900 text-lg mb-2">Our Address</h4>
                  <p className="text-gray-600 text-lg leading-relaxed">
                    2079 Global Ct<br />
                    Sarasota, FL 34240
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-fill text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-blue-900 text-lg mb-2">Call Us Today</h4>
                  <a 
                    href="tel:941.286.4000" 
                    className="text-2xl font-bold text-blue-600 hover:text-blue-800 transition-colors"
                  >
                    941.286.4000
                  </a>
                  <p className="text-gray-600 mt-1">Expert CPAP consultation and support</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-fill text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-blue-900 text-lg mb-2">Business Hours</h4>
                  <div className="text-gray-600 leading-relaxed">
                    <p className="font-semibold text-blue-900">Monday - Friday</p>
                    <p className="text-lg">10:00 AM - 4:00 PM</p>
                    <p className="mt-2 text-red-600 font-medium">Closed Saturday & Sunday</p>
                  </div>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-slate-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-pulse-fill text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-blue-900 text-lg mb-2">Our Specialty</h4>
                  <p className="text-gray-600 leading-relaxed">
                    Home Medical Equipment (HME) specializing in CPAP & BiPAP machines, 
                    masks, and supplies for sleep apnea treatment.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <a 
                href="tel:941.286.4000" 
                className="w-full bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-blue-900 px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 text-center block whitespace-nowrap shadow-lg hover:shadow-xl"
              >
                <i className="ri-phone-fill mr-2"></i>
                Call for Equipment Consultation
              </a>
            </div>
          </div>

          {/* Map */}
          <div className="bg-white rounded-2xl p-4 shadow-2xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3544.123456789!2d-82.123456!3d27.123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2s2079+Global+Ct%2C+Sarasota%2C+FL+34240!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: '12px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="MediMar Medical Market Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
